import type React from 'react';

const MESSAGE_CLASSES =
    'text-[length:var(--malachite-font-size-small,13px)] text-left pl-2 text-[var(--malachite-destructive-foreground,rgb(196,62,62))]';

interface FieldMessageProps {
    id?: string;
    message?: string;
    /** The controls that sit their message under a helper line need the gap; `Input` does not. */
    spaced?: boolean;
}

/**
 * A field's validation message. The live region is mounted whether or not there is anything
 * to say, because a region inserted with its text already inside it is not a mutation and
 * screen readers stay silent — which would lose the first rejection, the one that matters.
 * Out of flow while empty, so a flex parent's `gap` reserves no space beside it.
 */
export const FieldMessage: React.FC<FieldMessageProps> = ({ id, message, spaced = false }) => (
    <div
        id={id}
        // Polite rather than assertive: the message is also the field's description via
        // aria-describedby, and an interrupting region says it a second time.
        aria-live="polite"
        className={message ? `${spaced ? 'mt-1 ' : ''}${MESSAGE_CLASSES}` : 'absolute'}
    >
        {message}
    </div>
);

export default FieldMessage;
